<template>
  <div id="talent">
    <div class="breadcrumb">
      达人管理
      <el-button class="right_f" type="primary" @click="addNewTalent"
        >新增</el-button
      >
    </div>
    <div class="search-box">
      <el-select class="search-item" v-model="searchType">
        <el-option label="达人Id" value="1"></el-option>
        <el-option label="达人姓名" value="2"></el-option>
        <el-option label="手机号" value="3"></el-option>
      </el-select>
      <el-input
        class="search-item-long"
        v-model="searchValue"
        :placeholder="placeholder"
      ></el-input>

      <el-select
        class="search-item-long"
        v-model="unid"
        filterable
        clearable
        placeholder="请选择校区"
      >
        <el-option
          v-for="item in zoneList"
          :value="item.unid"
          :label="item.name"
          :key="item.unid"
        >
        </el-option>
      </el-select>
      <br />
      <span>发视频功能：</span>
      <el-select class="search-item" v-model="videoEnable">
        <el-option label="全部" value="-1"></el-option>
        <el-option label="已开通" value="0"></el-option>
        <el-option label="已关闭" value="1"></el-option>
      </el-select>
      <span style="padding-left: 20px">是否达人：</span>
      <el-select class="search-item" v-model="enable">
        <el-option label="是" value="0"></el-option>
        <el-option label="否" value="1"></el-option>
      </el-select>

      <el-button type="primary" @click="getTalentList">搜索</el-button>
    </div>

    <div class="talent-box">
      <el-table :data="talentList" style="overflow-x: auto">
        <el-table-column prop="talentId" label="达人ID"></el-table-column>
        <el-table-column
          prop="phoneNumber"
          label="手机号"
          width="130"
        ></el-table-column>
        <el-table-column prop="name" label="姓名"></el-table-column>
        <el-table-column prop="zoneName" label="校区"></el-table-column>
        <el-table-column prop="className" label="院系"></el-table-column>
        <el-table-column prop="dynamicNum" label="动态数"></el-table-column>
        <el-table-column prop="fansNum" label="粉丝"></el-table-column>
        <el-table-column prop="interestNum" label="关注"></el-table-column>
        <el-table-column prop="praiseNum" label="获赞"></el-table-column>
        <el-table-column prop="createUser" label="创建人"></el-table-column>
        <el-table-column inline-template label="操作" width="120">
          <div>
            <el-button type="text" class="edit-btn" @click="toTalentDetail(row)"
              >查看</el-button
            >
            <el-button
              type="text"
              class="edit-btn"
              v-if="row.enable == 1"
              @click="openOrCloseTalent(row)"
            >
              再次开通</el-button
            >
            <el-button
              type="text"
              class="edit-btn"
              v-if="row.enable == 0"
              @click="openOrCloseTalent(row)"
            >
              取消达人</el-button
            >
            <el-button
              type="text"
              class="edit-btn"
              v-if="row.videoEnable == 0 && row.enable == 0"
              @click="openOrCloseVideo(row)"
              >取消视频功能
            </el-button>
            <el-button
              type="text"
              class="edit-btn"
              v-if="row.videoEnable == 1 && row.enable == 0"
              @click="openOrCloseVideo(row)"
              >开通视频功能
            </el-button>
          </div>
        </el-table-column>
      </el-table>
    </div>

    <div class="pagination">
      <el-pagination
        v-show="totalCount > 0"
        layout="prev, pager, next, jumper"
        :page-size="pageSize"
        :current-page="pageNum"
        :total="totalCount"
        @current-change="handleCurrentChange"
      >
      </el-pagination>
    </div>
    <el-dialog
      :title="diaTitle"
      v-model="dialogFormVisible"
      :modal-append-to-body="false"
    >
      <el-form>
        <el-form-item :label-width="formLabelWidth">
          <el-input
            v-model="reason"
            type="textarea"
            :rows="3"
            placeholder="请输入原因说明"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="sendCancleReson">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      talentList: [],
      pageNum: 1,
      pageSize: 20,
      totalCount: 0,
      zoneList: [],
      searchType: "1",
      searchValue: "",
      placeholder: "请输入达人ID",
      videoEnable: "-1",
      enable: "0",
      diaTitle: "",
      dialogFormVisible: false,
      reason: "",
      query: null,
    };
  },
  watch: {
    searchType() {
      this.searchValue = "";
      if (this.searchType == 2) {
        this.placeholder = "请输入达人姓名";
      } else if (this.searchType == 3) {
        this.placeholder = "请输入达人手机号";
      } else {
        this.placeholder = "请输入达人ID";
      }
    },
    dialogFormVisible() {
      if (!this.dialogFormVisible) {
        this.query = null;
      }
    },
  },
  mounted() {
    this.getTalentList();
    this.getschoolandunid();
  },
  methods: {
    getTalentList(num) {
      this.totalCount = 0;
      this.talentList = [];
      if (!num) {
        this.pageNum = 1;
      }

      let url = this.$util.domain + "/talent/findForPage";
      let query = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        enable: this.enable * 1,
        videoEnable: this.videoEnable * 1,
        unid: this.unid ? this.unid : -1,
      };

      if (this.searchType == 1) {
        query.talentId = this.searchValue.trim();
      } else if (this.searchType == 2) {
        query.name = this.searchValue.trim();
      } else {
        query.phoneNumber = this.searchValue.trim();
      }

      this.$http({
        method: "POST",
        url: url,
        body: JSON.stringify(query),
      }).then((res) => {
        if (res.data.error == 10000) {
          let preObj = res.data.data;
          this.totalCount = preObj.totalCount * 1 || 0;
          if (preObj.content && preObj.content.length > 0) {
            this.talentList = [...preObj.content];
          }
        }
      });
    },

    // 开通/取消达人
    openOrCloseTalent(row) {
      let enableType = row.enable == 1 ? true : false;
      let query = {
        talentId: row.talentId,
        type: 0,
        enable: enableType,
      };

      if (enableType) {
        // 开通
        this.$confirm("你确定要开通达人吗？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(() => {
          this.sendCommonUpdateRequest(query);
        });
      } else {
        // 取消
        this.diaTitle = "请填写取消达人原因：";
        this.dialogFormVisible = true;
        this.query = query;
      }
    },

    // 开通/取消视频功能
    openOrCloseVideo(row) {
      let enableType = row.videoEnable == 1 ? true : false;
      let query = {
        talentId: row.talentId,
        type: 1,
        enable: enableType,
      };
      if (enableType) {
        // 开通
        this.$confirm("你确定要开通视频功能吗？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(() => {
          this.sendCommonUpdateRequest(query);
        });
      } else {
        // 取消
        this.diaTitle = "请填写取消视频功能原因：";
        this.dialogFormVisible = true;
        this.query = query;
      }
    },

    sendCancleReson() {
      let query = this.query;
      if (!this.reason || !this.reason.trim()) {
        return this.$util.errorMsg("请填写原因说明！");
      }
      if (query && !JSON.stringify(query) !== "{}") {
        query.reason = this.reason;
        this.sendCommonUpdateRequest(query);
      }
    },
    // 提交更改请求
    sendCommonUpdateRequest(query) {
      let url = this.$util.domain + "/talent/update";

      this.$http({
        method: "POST",
        url: url,
        body: JSON.stringify(query),
      })
        .then((res) => {
          this.dialogFormVisible = false;
          if (res.data.error == 10000) {
            this.getTalentList(this.pageNum);
          } else {
            this.$util.errorMsg(res.data.message);
          }
        })
        .catch((_) => {
          this.dialogFormVisible = false;
          this.$util.errorMsg("请求失败");
        });
    },

    addNewTalent() {
      location.href = "#/yunying/talent/newTalent";
    },

    toTalentDetail(row) {
      location.href = "#/yunying/talent/talentDetail?talentId=" + row.talentId;
    },

    getschoolandunid() {
      this.$http({
        method: "get",
        url: this.$util.domain + "/adminapi/v1/basicTools/allCampusZones",
      }).then((response) => {
        this.zoneList = response.body.data;
      });
    },

    handleCurrentChange(val) {
      this.pageNum = val * 1;
      this.getTalentList(val);
    },
  },
};
</script>
<style scoped>
.search-box,
.talent-box {
  padding: 0 20px;
  margin-bottom: 20px;
}

.search-item {
  display: inline-block;
  width: 150px;
  margin-bottom: 10px;
}

.search-item-long {
  display: inline-block;
  width: 300px;
  margin-bottom: 10px;
}

.edit-btn {
  margin-left: 0;
  margin-right: 10px;
}
</style>



// WEBPACK FOOTER //
// talentManage.vue?28051429